import { IntlShape } from 'react-intl';

import { IDocUploaderForm } from '@/shared/store/doc-uploader/types';
import { isExpiresLocked } from '@/shared/store/doc-uploader/upload-form';

const getExpiryValidation = (
  intl: IntlShape,
  isExpires: boolean | undefined,
  expiresAt: Date | null | undefined,
): string | undefined => {
  if (!isExpires) {
    return undefined;
  }

  if (!expiresAt) {
    return intl.formatMessage({
      defaultMessage: 'Required field',
      id: '+YX9Pa',
      description: 'Upload form: validation message',
    });
  }

  if (expiresAt <= new Date()) {
    return intl.formatMessage({
      defaultMessage: "Document's expiry date must be later than today",
      id: '3E0zuF',
      description: 'Upload form: validation message',
    });
  }

  return undefined;
};

// a locked date cannot be edited, so its validation must not block saving
const getBlockingExpiryError = <TDocType>(
  intl: IntlShape,
  isExpires: boolean | undefined,
  form: IDocUploaderForm<TDocType>,
) => (isExpiresLocked(form) ? undefined : getExpiryValidation(intl, isExpires, form.expiresAt));

export { getExpiryValidation, getBlockingExpiryError };
